import React from 'react';
import './Cursor.css';

const Cursor = () => (
  <>
    <div id="cursor" />
    <div id="cursor-ring" />
  </>
);

export default Cursor;
